import { useState } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function NavBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-sm font-bold text-foreground-950">我的朋友他的妻子</span>
            <span className="text-[11px] text-foreground-500">全文阅读与故事导览</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#channels"
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:inline-flex"
        >
          阅读入口
        </a>

        <button
          type="button"
          aria-label="打开或关闭导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col px-4 py-2 md:px-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#channels"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              阅读入口
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}